import * as i4 from '@angular/common';
import { isPlatformBrowser, DOCUMENT, CommonModule } from '@angular/common';
import * as i2 from '@angular/common/http';
import { HttpEventType } from '@angular/common/http';
import * as i0 from '@angular/core';
import { EventEmitter, PLATFORM_ID, LOCALE_ID, booleanAttribute, numberAttribute, Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, Input, Output, ContentChildren, ViewChild, NgModule } from '@angular/core';
import * as i3 from 'primeng/api';
import { TranslationKeys, PrimeTemplate, SharedModule } from 'primeng/api';
import * as i5 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import { DomHandler } from 'primeng/dom';
import { PlusIcon } from 'primeng/icons/plus';
import { TimesIcon } from 'primeng/icons/times';
import { UploadIcon } from 'primeng/icons/upload';
import * as i7 from 'primeng/messages';
import { MessagesModule } from 'primeng/messages';
import * as i6 from 'primeng/progressbar';
import { ProgressBarModule } from 'primeng/progressbar';
import * as i8 from 'primeng/ripple';
import { RippleModule } from 'primeng/ripple';
import * as i1 from '@angular/platform-browser';

/**
 * FileUpload is an advanced uploader with dragdrop support, multi file uploads, auto uploading, progress tracking and validations.
 * @group Components
 */
const _c0 = ["advancedfileinput"];
const _c1 = ["basicfileinput"];
const _c2 = ["content"];
const _c3 = (a0, a1, a2, a3, a4) => ({
  $implicit: a0,
  uploadedFiles: a1,
  chooseCallback: a2,
  clearCallback: a3,
  uploadCallback: a4
});
const _c4 = (a0, a1, a2, a3, a4, a5, a6, a7) => ({
  $implicit: a0,
  uploadedFiles: a1,
  chooseCallback: a2,
  clearCallback: a3,
  removeUploadedFileCallback: a4,
  removeFileCallback: a5,
  progress: a6,
  messages: a7
});
const _c5 = (a0, a1) => ({
  "p-focus": a0,
  "p-disabled": a1
});
const _c6 = (a0, a1, a2, a3) => ({
  "p-button p-component p-fileupload-choose": true,
  "p-button-icon-only": a0,
  "p-fileupload-choose-selected": a1,
  "p-focus": a2,
  "p-disabled": a3
});
function FileUpload_div_0_ng_container_4_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 21);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r1.chooseIcon);
    i0.ɵɵproperty("ngClass", "p-button-icon p-button-icon-left");
    i0.ɵɵattribute("aria-label", true)("data-pc-section", "chooseicon");
  }
}
function FileUpload_div_0_ng_container_4_ng_container_5_PlusIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "PlusIcon", 24);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-button-icon p-button-icon-left");
    i0.ɵɵattribute("aria-label", true)("data-pc-section", "chooseicon");
  }
}
function FileUpload_div_0_ng_container_4_ng_container_5_span_2_1_ng_template_0_Template(rf, ctx) {}
function FileUpload_div_0_ng_container_4_ng_container_5_span_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FileUpload_div_0_ng_container_4_ng_container_5_span_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function FileUpload_div_0_ng_container_4_ng_container_5_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtemplate(1, FileUpload_div_0_ng_container_4_ng_container_5_span_2_1_Template, 1, 0, null, 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-label", true)("data-pc-section", "chooseicon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.chooseIconTemplate);
  }
}
function FileUpload_div_0_ng_container_4_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FileUpload_div_0_ng_container_4_ng_container_5_PlusIcon_1_Template, 1, 3, "PlusIcon", 22)(2, FileUpload_div_0_ng_container_4_ng_container_5_span_2_Template, 2, 3, "span", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.chooseIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.chooseIconTemplate);
  }
}
function FileUpload_div_0_ng_container_4_p_button_8_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 28);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", ctx_r1.uploadIcon);
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function FileUpload_div_0_ng_container_4_p_button_8_ng_container_2_UploadIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "UploadIcon", 24);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-button-icon p-button-icon-left");
  }
}
function FileUpload_div_0_ng_container_4_p_button_8_ng_container_2_span_2_1_ng_template_0_Template(rf, ctx) {}
function FileUpload_div_0_ng_container_4_p_button_8_ng_container_2_span_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FileUpload_div_0_ng_container_4_p_button_8_ng_container_2_span_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function FileUpload_div_0_ng_container_4_p_button_8_ng_container_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtemplate(1, FileUpload_div_0_ng_container_4_p_button_8_ng_container_2_span_2_1_Template, 1, 0, null, 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵattribute("aria-hidden", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.uploadIconTemplate);
  }
}
function FileUpload_div_0_ng_container_4_p_button_8_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FileUpload_div_0_ng_container_4_p_button_8_ng_container_2_UploadIcon_1_Template, 1, 1, "UploadIcon", 22)(2, FileUpload_div_0_ng_container_4_p_button_8_ng_container_2_span_2_Template, 2, 2, "span", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.uploadIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.uploadIconTemplate);
  }
}
function FileUpload_div_0_ng_container_4_p_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 26);
    i0.ɵɵlistener("onClick", function FileUpload_div_0_ng_container_4_p_button_8_Template_p_button_onClick_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.upload());
    });
    i0.ɵɵtemplate(1, FileUpload_div_0_ng_container_4_p_button_8_span_1_Template, 1, 2, "span", 27)(2, FileUpload_div_0_ng_container_4_p_button_8_ng_container_2_Template, 3, 2, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("label", ctx_r1.uploadButtonLabel)("disabled", !ctx_r1.hasFiles() || ctx_r1.isFileLimitExceeded())("styleClass", ctx_r1.uploadStyleClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.uploadIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.uploadIcon);
  }
}
function FileUpload_div_0_ng_container_4_p_button_9_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 28);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", ctx_r1.cancelIcon);
  }
}
function FileUpload_div_0_ng_container_4_p_button_9_ng_container_2_TimesIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "TimesIcon", 24);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-button-icon p-button-icon-left");
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function FileUpload_div_0_ng_container_4_p_button_9_ng_container_2_span_2_1_ng_template_0_Template(rf, ctx) {}
function FileUpload_div_0_ng_container_4_p_button_9_ng_container_2_span_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FileUpload_div_0_ng_container_4_p_button_9_ng_container_2_span_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function FileUpload_div_0_ng_container_4_p_button_9_ng_container_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtemplate(1, FileUpload_div_0_ng_container_4_p_button_9_ng_container_2_span_2_1_Template, 1, 0, null, 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵattribute("aria-hidden", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.cancelIconTemplate);
  }
}
function FileUpload_div_0_ng_container_4_p_button_9_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FileUpload_div_0_ng_container_4_p_button_9_ng_container_2_TimesIcon_1_Template, 1, 2, "TimesIcon", 22)(2, FileUpload_div_0_ng_container_4_p_button_9_ng_container_2_span_2_Template, 2, 2, "span", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.cancelIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.cancelIconTemplate);
  }
}
function FileUpload_div_0_ng_container_4_p_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 26);
    i0.ɵɵlistener("onClick", function FileUpload_div_0_ng_container_4_p_button_9_Template_p_button_onClick_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clear());
    });
    i0.ɵɵtemplate(1, FileUpload_div_0_ng_container_4_p_button_9_span_1_Template, 1, 1, "span", 27)(2, FileUpload_div_0_ng_container_4_p_button_9_ng_container_2_Template, 3, 2, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("label", ctx_r1.cancelButtonLabel)("disabled", !ctx_r1.hasFiles() || ctx_r1.uploading)("styleClass", ctx_r1.cancelStyleClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.cancelIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.cancelIcon);
  }
}
function FileUpload_div_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 17);
    i0.ɵɵlistener("focus", function FileUpload_div_0_ng_container_4_Template_span_focus_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onFocus());
    })("blur", function FileUpload_div_0_ng_container_4_Template_span_blur_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onBlur());
    })("click", function FileUpload_div_0_ng_container_4_Template_span_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.choose());
    })("keydown.enter", function FileUpload_div_0_ng_container_4_Template_span_keydown_enter_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.choose());
    });
    i0.ɵɵelementStart(2, "input", 7, 0);
    i0.ɵɵlistener("change", function FileUpload_div_0_ng_container_4_Template_input_change_2_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onFileSelect($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FileUpload_div_0_ng_container_4_span_4_Template, 1, 5, "span", 18)(5, FileUpload_div_0_ng_container_4_ng_container_5_Template, 3, 2, "ng-container", 9);
    i0.ɵɵelementStart(6, "span", 19);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, FileUpload_div_0_ng_container_4_p_button_8_Template, 3, 5, "p-button", 20)(9, FileUpload_div_0_ng_container_4_p_button_9_Template, 3, 5, "p-button", 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.chooseStyleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(16, _c5, ctx_r1.focus, ctx_r1.disabled || ctx_r1.isChooseDisabled()));
    i0.ɵɵattribute("data-pc-section", "choosebutton");
    i0.ɵɵadvance();
    i0.ɵɵproperty("multiple", ctx_r1.multiple)("accept", ctx_r1.accept)("disabled", ctx_r1.disabled || ctx_r1.isChooseDisabled());
    i0.ɵɵattribute("aria-label", ctx_r1.browseFilesLabel)("title", "")("data-pc-section", "input");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.chooseIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.chooseIcon);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-pc-section", "choosebuttonlabel");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.chooseButtonLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.auto && ctx_r1.showUploadButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.auto && ctx_r1.showCancelButton);
  }
}
function FileUpload_div_0_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FileUpload_div_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FileUpload_div_0_p_progressBar_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-progressBar", 29);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", ctx_r1.progress)("showValue", false);
  }
}
function FileUpload_div_0_div_11_div_1_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "img", 35);
    i0.ɵɵlistener("error", function FileUpload_div_0_div_11_div_1_div_1_div_1_Template_img_error_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.imageError($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const file_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", file_r8.objectURL, i0.ɵɵsanitizeUrl)("width", ctx_r1.previewWidth);
  }
}
function FileUpload_div_0_div_11_div_1_div_1_TimesIcon_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "TimesIcon");
  }
}
function FileUpload_div_0_div_11_div_1_div_1_9_ng_template_0_Template(rf, ctx) {}
function FileUpload_div_0_div_11_div_1_div_1_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FileUpload_div_0_div_11_div_1_div_1_9_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function FileUpload_div_0_div_11_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtemplate(1, FileUpload_div_0_div_11_div_1_div_1_div_1_Template, 2, 2, "div", 9);
    i0.ɵɵelementStart(2, "div", 33);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div")(7, "button", 34);
    i0.ɵɵlistener("click", function FileUpload_div_0_div_11_div_1_div_1_Template_button_click_7_listener($event) {
      const i_r9 = i0.ɵɵrestoreView(_r6).index;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.remove($event, i_r9));
    });
    i0.ɵɵtemplate(8, FileUpload_div_0_div_11_div_1_div_1_TimesIcon_8_Template, 1, 0, "TimesIcon", 9)(9, FileUpload_div_0_div_11_div_1_div_1_9_Template, 1, 0, null, 11);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const file_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isImage(file_r8));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(file_r8.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.formatSize(file_r8.size));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r1.removeStyleClass);
    i0.ɵɵproperty("disabled", ctx_r1.uploading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.cancelIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.cancelIconTemplate);
  }
}
function FileUpload_div_0_div_11_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FileUpload_div_0_div_11_div_1_div_1_Template, 10, 8, "div", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.files);
  }
}
function FileUpload_div_0_div_11_div_2_ng_template_1_Template(rf, ctx) {}
function FileUpload_div_0_div_11_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FileUpload_div_0_div_11_div_2_ng_template_1_Template, 0, 0, "ng-template", 36);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.files)("ngForTemplate", ctx_r1.fileTemplate);
  }
}
function FileUpload_div_0_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, FileUpload_div_0_div_11_div_1_Template, 2, 1, "div", 9)(2, FileUpload_div_0_div_11_div_2_Template, 2, 2, "div", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.fileTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.fileTemplate);
  }
}
function FileUpload_div_0_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FileUpload_div_0_div_13_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FileUpload_div_0_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtemplate(1, FileUpload_div_0_div_13_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.emptyTemplate);
  }
}
function FileUpload_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "input", 7, 0);
    i0.ɵɵlistener("change", function FileUpload_div_0_Template_input_change_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFileSelect($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtemplate(4, FileUpload_div_0_ng_container_4_Template, 10, 19, "ng-container", 9)(5, FileUpload_div_0_ng_container_5_Template, 1, 0, "ng-container", 10)(6, FileUpload_div_0_ng_container_6_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 12, 1);
    i0.ɵɵlistener("dragenter", function FileUpload_div_0_Template_div_dragenter_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDragEnter($event));
    })("dragleave", function FileUpload_div_0_Template_div_dragleave_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDragLeave($event));
    })("drop", function FileUpload_div_0_Template_div_drop_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDrop($event));
    });
    i0.ɵɵtemplate(9, FileUpload_div_0_p_progressBar_9_Template, 1, 2, "p-progressBar", 13);
    i0.ɵɵelement(10, "p-messages", 14);
    i0.ɵɵtemplate(11, FileUpload_div_0_div_11_Template, 3, 2, "div", 15)(12, FileUpload_div_0_ng_container_12_Template, 1, 0, "ng-container", 10)(13, FileUpload_div_0_div_13_Template, 2, 1, "div", 16);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.styleClass);
    i0.ɵɵproperty("ngClass", "p-fileupload p-fileupload-advanced p-component")("ngStyle", ctx_r1.style);
    i0.ɵɵattribute("data-pc-name", "fileupload")("data-pc-section", "root");
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("display", "none");
    i0.ɵɵproperty("multiple", ctx_r1.multiple)("accept", ctx_r1.accept)("disabled", ctx_r1.disabled || ctx_r1.isChooseDisabled());
    i0.ɵɵattribute("aria-label", ctx_r1.browseFilesLabel)("title", "")("data-pc-section", "input");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("data-pc-section", "buttonbar");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction5(27, _c3, ctx_r1.files, ctx_r1.uploadedFiles, ctx_r1.choose.bind(ctx_r1), ctx_r1.clear.bind(ctx_r1), ctx_r1.upload.bind(ctx_r1)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.toolbarTemplate);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-pc-section", "content");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.hasFiles());
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r1.msgs)("enableService", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hasFiles());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.contentTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction8(33, _c4, ctx_r1.files, ctx_r1.uploadedFiles, ctx_r1.choose.bind(ctx_r1), ctx_r1.clear.bind(ctx_r1), ctx_r1.removeUploadedFile.bind(ctx_r1), ctx_r1.remove.bind(ctx_r1), ctx_r1.progress, ctx_r1.msgs));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.emptyTemplate && !ctx_r1.hasFiles() && !ctx_r1.hasUploadedFiles());
  }
}
function FileUpload_div_1_ng_container_3_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 28);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r1.uploadIcon);
  }
}
function FileUpload_div_1_ng_container_3_ng_container_2_UploadIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "UploadIcon", 24);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-button-icon p-button-icon-left");
  }
}
function FileUpload_div_1_ng_container_3_ng_container_2_span_2_1_ng_template_0_Template(rf, ctx) {}
function FileUpload_div_1_ng_container_3_ng_container_2_span_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FileUpload_div_1_ng_container_3_ng_container_2_span_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function FileUpload_div_1_ng_container_3_ng_container_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtemplate(1, FileUpload_div_1_ng_container_3_ng_container_2_span_2_1_Template, 1, 0, null, 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.uploadIconTemplate);
  }
}
function FileUpload_div_1_ng_container_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FileUpload_div_1_ng_container_3_ng_container_2_UploadIcon_1_Template, 1, 1, "UploadIcon", 22)(2, FileUpload_div_1_ng_container_3_ng_container_2_span_2_Template, 2, 1, "span", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.uploadIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.uploadIconTemplate);
  }
}
function FileUpload_div_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FileUpload_div_1_ng_container_3_span_1_Template, 1, 1, "span", 27)(2, FileUpload_div_1_ng_container_3_ng_container_2_Template, 3, 2, "ng-container", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.uploadIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.uploadIcon);
  }
}
function FileUpload_div_1_ng_template_4_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 44);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r1.chooseIcon);
  }
}
function FileUpload_div_1_ng_template_4_ng_container_1_PlusIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "PlusIcon", 24);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-button-icon p-button-icon-left pi");
    i0.ɵɵattribute("aria-hidden", true)("data-pc-section", "uploadicon");
  }
}
function FileUpload_div_1_ng_template_4_ng_container_1_span_2_1_ng_template_0_Template(rf, ctx) {}
function FileUpload_div_1_ng_template_4_ng_container_1_span_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FileUpload_div_1_ng_template_4_ng_container_1_span_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function FileUpload_div_1_ng_template_4_ng_container_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 46);
    i0.ɵɵtemplate(1, FileUpload_div_1_ng_template_4_ng_container_1_span_2_1_Template, 1, 0, null, 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-hidden", true)("data-pc-section", "uploadicon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.chooseIconTemplate);
  }
}
function FileUpload_div_1_ng_template_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FileUpload_div_1_ng_template_4_ng_container_1_PlusIcon_1_Template, 1, 3, "PlusIcon", 22)(2, FileUpload_div_1_ng_template_4_ng_container_1_span_2_Template, 2, 3, "span", 45);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.chooseIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.chooseIconTemplate);
  }
}
function FileUpload_div_1_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FileUpload_div_1_ng_template_4_span_0_Template, 1, 1, "span", 43)(1, FileUpload_div_1_ng_template_4_ng_container_1_Template, 3, 2, "ng-container", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r1.chooseIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.chooseIcon);
  }
}
function FileUpload_div_1_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "label");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.basicButtonLabel);
  }
}
function FileUpload_div_1_input_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 47, 3);
    i0.ɵɵlistener("change", function FileUpload_div_1_input_7_Template_input_change_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onFileSelect($event));
    })("focus", function FileUpload_div_1_input_7_Template_input_focus_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onFocus());
    })("blur", function FileUpload_div_1_input_7_Template_input_blur_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("accept", ctx_r1.accept)("multiple", ctx_r1.multiple)("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("aria-label", ctx_r1.browseFilesLabel)("data-pc-section", "input");
  }
}
function FileUpload_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵelement(1, "p-messages", 14);
    i0.ɵɵelementStart(2, "span", 39);
    i0.ɵɵlistener("click", function FileUpload_div_1_Template_span_click_2_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBasicUploaderClick());
    })("keydown", function FileUpload_div_1_Template_span_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBasicKeydown($event));
    });
    i0.ɵɵtemplate(3, FileUpload_div_1_ng_container_3_Template, 3, 2, "ng-container", 40)(4, FileUpload_div_1_ng_template_4_Template, 2, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, FileUpload_div_1_span_6_Template, 2, 2, "span", 41)(7, FileUpload_div_1_input_7_Template, 2, 5, "input", 42);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const chooseSection_r12 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-pc-name", "fileupload");
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r1.msgs)("enableService", false);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.styleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(12, _c6, !ctx_r1.basicButtonLabel, ctx_r1.hasFiles(), ctx_r1.focus, ctx_r1.disabled))("ngStyle", ctx_r1.style);
    i0.ɵɵattribute("data-pc-section", "choosebutton");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hasFiles() && !ctx_r1.auto)("ngIfElse", chooseSection_r12);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.basicButtonLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.hasFiles());
  }
}
let FileUpload = /*#__PURE__*/(() => {
  class FileUpload {
    document;
    platformId;
    locale;
    renderer;
    el;
    sanitizer;
    zone;
    http;
    cd;
    config;
    /**
     * Name of the request parameter to identify the files at backend.
     * @group Props
     */
    name;
    /**
     * Remote url to upload the files.
     * @group Props
     */
    url;
    /**
     * HTTP method to send the files to the url such as "post" and "put".
     * @group Props
     */
    method = 'post';
    /**
     * Used to select multiple files at once from file dialog.
     * @group Props
     */
    multiple;
    /**
     * Comma-separated list of pattern to restrict the allowed file types. Can be any combination of either the MIME types (such as "image/*") or the file extensions (such as ".jpg").
     * @group Props
     */
    accept;
    /**
     * Disables the upload functionality.
     * @group Props
     */
    disabled;
    /**
     * When enabled, upload begins automatically after selection is completed.
     * @group Props
     */
    auto;
    /**
     * Cross-site Access-Control requests should be made using credentials such as cookies, authorization headers or TLS client certificates.
     * @group Props
     */
    withCredentials;
    /**
     * Maximum file size allowed in bytes.
     * @group Props
     */
    maxFileSize;
    /**
     * Summary message of the invalid file size.
     * @group Props
     */
    invalidFileSizeMessageSummary = '{0}: Invalid file size, ';
    /**
     * Detail message of the invalid file size.
     * @group Props
     */
    invalidFileSizeMessageDetail = 'maximum upload size is {0}.';
    /**
     * Summary message of the invalid file type.
     * @group Props
     */
    invalidFileTypeMessageSummary = '{0}: Invalid file type, ';
    /**
     * Detail message of the invalid file type.
     * @group Props
     */
    invalidFileTypeMessageDetail = 'allowed file types: {0}.';
    /**
     * Detail message of the invalid file type.
     * @group Props
     */
    invalidFileLimitMessageDetail = 'limit is {0} at most.';
    /**
     * Summary message of the invalid file type.
     * @group Props
     */
    invalidFileLimitMessageSummary = 'Maximum number of files exceeded, ';
    /**
     * Inline style of the element.
     * @group Props
     */
    style;
    /**
     * Class of the element.
     * @group Props
     */
    styleClass;
    /**
     * Width of the image thumbnail in pixels.
     * @group Props
     */
    previewWidth = 50;
    /**
     * Label of the choose button. Defaults to PrimeNG Locale configuration.
     * @group Props
     */
    chooseLabel;
    /**
     * Label of the upload button. Defaults to PrimeNG Locale configuration.
     * @group Props
     */
    uploadLabel;
    /**
     * Label of the cancel button. Defaults to PrimeNG Locale configuration.
     * @group Props
     */
    cancelLabel;
    /**
     * Icon of the choose button.
     * @group Props
     */
    chooseIcon;
    /**
     * Icon of the upload button.
     * @group Props
     */
    uploadIcon;
    /**
     * Icon of the cancel button.
     * @group Props
     */
    cancelIcon;
    /**
     * Whether to show the upload button.
     * @group Props
     */
    showUploadButton = true;
    /**
     * Whether to show the cancel button.
     * @group Props
     */
    showCancelButton = true;
    /**
     * Defines the UI of the component.
     * @group Props
     */
    mode = 'advanced';
    /**
     * HttpHeaders class represents the header configuration options for an HTTP request.
     * @group Props
     */
    headers;
    /**
     * Whether to use the default upload or a manual implementation defined in uploadHandler callback. Defaults to PrimeNG Locale configuration.
     * @group Props
     */
    customUpload;
    /**
     * Maximum number of files that can be uploaded.
     * @group Props
     */
    fileLimit;
    /**
     * Style class of the upload button.
     * @group Props
     */
    uploadStyleClass;
    /**
     * Style class of the cancel button.
     * @group Props
     */
    cancelStyleClass;
    /**
     * Style class of the remove button.
     * @group Props
     */
    removeStyleClass;
    /**
     * Style class of the choose button.
     * @group Props
     */
    chooseStyleClass;
    /**
     * Callback to invoke before file upload is initialized.
     * @param {FileBeforeUploadEvent} event - Custom upload event.
     * @group Emits
     */
    onBeforeUpload = new EventEmitter();
    /**
     * An event indicating that the request was sent to the server. Useful when a request may be retried multiple times, to distinguish between retries on the final event stream.
     * @param {FileSendEvent} event - Custom send event.
     * @group Emits
     */
    onSend = new EventEmitter();
    /**
     * Callback to invoke when file upload is complete.
     * @param {FileUploadEvent} event - Custom upload event.
     * @group Emits
     */
    onUpload = new EventEmitter();
    /**
     * Callback to invoke if file upload fails.
     * @param {FileUploadErrorEvent} event - Custom error event.
     * @group Emits
     */
    onError = new EventEmitter();
    /**
     * Callback to invoke when files in queue are removed without uploading using clear all button.
     * @param {Event} event - Browser event.
     * @group Emits
     */
    onClear = new EventEmitter();
    /**
     * Callback to invoke when a file is removed without uploading using clear button of a file.
     * @param {FileRemoveEvent} event - Remove event.
     * @group Emits
     */
    onRemove = new EventEmitter();
    /**
     * Callback to invoke when files are selected.
     * @param {FileSelectEvent} event - Select event.
     * @group Emits
     */
    onSelect = new EventEmitter();
    /**
     * Callback to invoke when files are being uploaded.
     * @param {FileProgressEvent} event - Progress event.
     * @group Emits
     */
    onProgress = new EventEmitter();
    /**
     * Callback to invoke in custom upload mode to upload the files manually.
     * @param {FileUploadHandlerEvent} event - Upload handler event.
     * @group Emits
     */
    uploadHandler = new EventEmitter();
    /**
     * This event is triggered if an error occurs while loading an image file.
     * @param {Event} event - Browser event.
     * @group Emits
     */
    onImageError = new EventEmitter();
    /**
     * This event is triggered if an error occurs while removing an uploaded file.
     * @param {RemoveUploadedFileEvent} event - Remove event.
     * @group Emits
     */
    onRemoveUploadedFile = new EventEmitter();
    templates;
    advancedFileInput;
    basicFileInput;
    content;
    set files(files) {
      this._files = [];
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        if (this.validate(file)) {
          if (this.isImage(file)) {
            file.objectURL = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(files[i]));
          }
          this._files.push(files[i]);
        }
      }
    }
    get files() {
      return this._files;
    }
    get basicButtonLabel() {
      if (this.auto || !this.hasFiles()) {
        return this.chooseLabel;
      }
      return this.uploadLabel ?? this.files[0].name;
    }
    _files = [];
    progress = 0;
    dragHighlight;
    msgs;
    fileTemplate;
    headerTemplate;
    contentTemplate;
    toolbarTemplate;
    chooseIconTemplate;
    uploadIconTemplate;
    cancelIconTemplate;
    emptyTemplate;
    uploadedFileCount = 0;
    focus;
    uploading;
    duplicateIEEvent; // flag to recognize duplicate onchange event for file input
    translationSubscription;
    dragOverListener;
    uploadedFiles = [];
    fileUploadSubcription;
    formatter;
    constructor(document, platformId, locale, renderer, el, sanitizer, zone, http, cd, config) {
      this.document = document;
      this.platformId = platformId;
      this.locale = locale;
      this.renderer = renderer;
      this.el = el;
      this.sanitizer = sanitizer;
      this.zone = zone;
      this.http = http;
      this.cd = cd;
      this.config = config;
      this.formatter = new Intl.NumberFormat(this.locale, {
        maximumFractionDigits: 3
      });
    }
    ngAfterContentInit() {
      this.templates?.forEach(item => {
        switch (item.getType()) {
          case 'header':
            this.headerTemplate = item.template;
            break;
          case 'file':
            this.fileTemplate = item.template;
            break;
          case 'content':
            this.contentTemplate = item.template;
            break;
          case 'toolbar':
            this.toolbarTemplate = item.template;
            break;
          case 'chooseicon':
            this.chooseIconTemplate = item.template;
            break;
          case 'uploadicon':
            this.uploadIconTemplate = item.template;
            break;
          case 'cancelicon':
            this.cancelIconTemplate = item.template;
            break;
          case 'empty':
            this.emptyTemplate = item.template;
            break;
          default:
            this.fileTemplate = item.template;
            break;
        }
      });
    }
    ngOnInit() {
      this.translationSubscription = this.config.translationObserver.subscribe(() => {
        this.cd.markForCheck();
      });
    }
    ngAfterViewInit() {
      if (isPlatformBrowser(this.platformId)) {
        if (this.mode === 'advanced') {
          this.zone.runOutsideAngular(() => {
            if (this.content) {
              this.dragOverListener = this.renderer.listen(this.content.nativeElement, 'dragover', this.onDragOver.bind(this));
            }
          });
        }
      }
    }
    getTranslation(option) {
      return this.config.getTranslation(option);
    }
    choose() {
      this.advancedFileInput?.nativeElement.click();
    }
    onFileSelect(event) {
      if (event.type !== 'drop' && this.isIE11() && this.duplicateIEEvent) {
        this.duplicateIEEvent = false;
        return;
      }
      this.msgs = [];
      if (!this.multiple) {
        this.files = [];
      }
      let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        if (!this.isFileSelected(file)) {
          if (this.validate(file)) {
            if (this.isImage(file)) {
              file.objectURL = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(files[i]));
            }
            this.files.push(files[i]);
          }
        }
      }
      this.onSelect.emit({
        originalEvent: event,
        files: files,
        currentFiles: this.files
      });
      // this will check the fileLimit with the uploaded files
      this.checkFileLimit(files);
      if (this.hasFiles() && this.auto && (this.mode !== 'advanced' || !this.isFileLimitExceeded())) {
        this.upload();
      }
      if (event.type !== 'drop' && this.isIE11()) {
        this.clearIEInput();
      } else {
        this.clearInputElement();
      }
    }
    isFileSelected(file) {
      for (let sFile of this.files) {
        if (sFile.name + sFile.type + sFile.size === file.name + file.type + file.size) {
          return true;
        }
      }
      return false;
    }
    isIE11() {
      if (isPlatformBrowser(this.platformId)) {
        return !!this.document.defaultView['MSInputMethodContext'] && !!this.document['documentMode'];
      }
    }
    validate(file) {
      this.msgs = this.msgs || [];
      if (this.accept && !this.isFileTypeValid(file)) {
        this.msgs.push({
          severity: 'error',
          summary: this.invalidFileTypeMessageSummary.replace('{0}', file.name),
          detail: this.invalidFileTypeMessageDetail.replace('{0}', this.accept)
        });
        return false;
      }
      if (this.maxFileSize && file.size > this.maxFileSize) {
        this.msgs.push({
          severity: 'error',
          summary: this.invalidFileSizeMessageSummary.replace('{0}', file.name),
          detail: this.invalidFileSizeMessageDetail.replace('{0}', this.formatSize(this.maxFileSize))
        });
        return false;
      }
      return true;
    }
    isFileTypeValid(file) {
      let acceptableTypes = this.accept?.split(',').map(type => type.trim());
      for (let type of acceptableTypes) {
        let acceptable = this.isWildcard(type) ? this.getTypeClass(file.type) === this.getTypeClass(type) : file.type == type || this.getFileExtension(file).toLowerCase() === type.toLowerCase();
        if (acceptable) {
          return true;
        }
      }
      return false;
    }
    getTypeClass(fileType) {
      return fileType.substring(0, fileType.indexOf('/'));
    }
    isWildcard(fileType) {
      return fileType.indexOf('*') !== -1;
    }
    getFileExtension(file) {
      return '.' + file.name.split('.').pop();
    }
    isImage(file) {
      return /^image\//.test(file.type);
    }
    onImageLoad(img) {
      window.URL.revokeObjectURL(img.src);
    }
    /**
     * Uploads the selected files.
     * @group Method
     */
    upload() {
      if (this.customUpload) {
        if (this.fileLimit) {
          this.uploadedFileCount += this.files.length;
        }
        this.uploadHandler.emit({
          files: this.files
        });
        this.cd.markForCheck();
      } else {
        this.uploading = true;
        this.msgs = [];
        let formData = new FormData();
        this.onBeforeUpload.emit({
          formData: formData
        });
        for (let i = 0; i < this.files.length; i++) {
          formData.append(this.name, this.files[i], this.files[i].name);
        }
        // If the previous upload hasn't been finished, it is aborted.
        this.cancelUploadRequest();
        this.fileUploadSubcription = this.http.request(this.method, this.url, {
          body: formData,
          headers: this.headers,
          reportProgress: true,
          observe: 'events',
          withCredentials: this.withCredentials
        }).subscribe(event => {
          switch (event.type) {
            case HttpEventType.Sent:
              this.onSend.emit({
                originalEvent: event,
                formData: formData
              });
              break;
            case HttpEventType.Response:
              this.uploading = false;
              this.progress = 0;
              if (event['status'] >= 200 && event['status'] < 300) {
                if (this.fileLimit) {
                  this.uploadedFileCount += this.files.length;
                }
                this.onUpload.emit({
                  originalEvent: event,
                  files: this.files
                });
              } else {
                this.onError.emit({
                  files: this.files
                });
              }
              this.uploadedFiles.push(...this.files);
              this.clear();
              break;
            case HttpEventType.UploadProgress:
              {
                if (event['loaded']) {
                  this.progress = Math.round(event['loaded'] * 100 / event['total']);
                }
                this.onProgress.emit({
                  originalEvent: event,
                  progress: this.progress
                });
                break;
              }
          }
          this.cd.markForCheck();
        }, error => {
          this.uploading = false;
          this.onError.emit({
            files: this.files,
            error: error
          });
        });
      }
    }
    /**
     * Clears the files list.
     * @group Method
     */
    clear() {
      this.files = [];
      this.uploadedFileCount = 0;
      this.cancelUploadRequest();
      this.onClear.emit();
      this.clearInputElement();
      this.cd.markForCheck();
    }
    /**
     * Removes a single file.
     * @param {Event} event - Browser event.
     * @param {Number} index - Index of the file.
     * @group Method
     */
    remove(event, index) {
      this.cancelUploadRequest();
      this.clearInputElement();
      this.onRemove.emit({
        originalEvent: event,
        file: this.files[index]
      });
      this.files.splice(index, 1);
      this.checkFileLimit(this.files);
    }
    /**
     * Removes uploaded file.
     * @param {Number} index - Index of the file to be removed.
     * @group Method
     */
    removeUploadedFile(index) {
      let removedFile = this.uploadedFiles.splice(index, 1)[0];
      this.uploadedFiles = [...this.uploadedFiles];
      this.onRemoveUploadedFile.emit({
        file: removedFile,
        files: this.uploadedFiles
      });
    }
    /**
     * Cancel upload file request.
     * */
    cancelUploadRequest() {
      if (this.fileUploadSubcription) {
        this.fileUploadSubcription.unsubscribe();
        this.fileUploadSubcription = undefined;
      }
    }
    isFileLimitExceeded() {
      const isAutoMode = this.auto;
      const totalFileCount = isAutoMode ? this.files.length : this.files.length + this.uploadedFileCount;
      if (this.fileLimit && this.fileLimit <= totalFileCount && this.focus) {
        this.focus = false;
      }
      return this.fileLimit && this.fileLimit < totalFileCount;
    }
    isChooseDisabled() {
      if (this.auto) {
        return this.fileLimit && this.fileLimit <= this.files.length;
      } else {
        return this.fileLimit && this.fileLimit <= this.files.length + this.uploadedFileCount;
      }
    }
    checkFileLimit(files) {
      this.msgs ??= [];
      const hasExistingValidationMessages = this.msgs.length > 0 && this.fileLimit < files.length;
      if (this.isFileLimitExceeded() || hasExistingValidationMessages) {
        this.msgs.push({
          severity: 'error',
          summary: this.invalidFileLimitMessageSummary.replace('{0}', this.fileLimit.toString()),
          detail: this.invalidFileLimitMessageDetail.replace('{0}', this.fileLimit.toString())
        });
      }
    }
    clearInputElement() {
      if (this.advancedFileInput && this.advancedFileInput.nativeElement) {
        this.advancedFileInput.nativeElement.value = '';
      }
      if (this.basicFileInput && this.basicFileInput.nativeElement) {
        this.basicFileInput.nativeElement.value = '';
      }
    }
    clearIEInput() {
      if (this.advancedFileInput && this.advancedFileInput.nativeElement) {
        this.duplicateIEEvent = true; //IE11 fix to prevent onFileChange trigger again
        this.advancedFileInput.nativeElement.value = '';
      }
    }
    hasFiles() {
      return this.files && this.files.length > 0;
    }
    hasUploadedFiles() {
      return this.uploadedFiles && this.uploadedFiles.length > 0;
    }
    onDragEnter(e) {
      if (!this.disabled) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
    onDragOver(e) {
      if (!this.disabled) {
        DomHandler.addClass(this.content?.nativeElement, 'p-fileupload-highlight');
        this.dragHighlight = true;
        e.stopPropagation();
        e.preventDefault();
      }
    }
    onDragLeave(event) {
      if (!this.disabled) {
        DomHandler.removeClass(this.content?.nativeElement, 'p-fileupload-highlight');
      }
    }
    onDrop(event) {
      if (!this.disabled) {
        DomHandler.removeClass(this.content?.nativeElement, 'p-fileupload-highlight');
        event.stopPropagation();
        event.preventDefault();
        let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        let allowDrop = this.multiple || files && files.length === 1;
        if (allowDrop) {
          this.onFileSelect(event);
        }
      }
    }
    onFocus() {
      this.focus = true;
    }
    onBlur() {
      this.focus = false;
    }
    formatSize(bytes) {
      const k = 1024;
      const sizes = this.getTranslation(TranslationKeys.FILE_SIZE_TYPES);
      if (bytes === 0) {
        return `0 ${sizes[0]}`;
      }
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      const formattedSize = this.formatter.format(bytes / Math.pow(k, i));
      return `${formattedSize} ${sizes[i]}`;
    }
    onBasicUploaderClick() {
      if (this.hasFiles()) this.upload();else this.basicFileInput?.nativeElement.click();
    }
    onBasicKeydown(event) {
      switch (event.code) {
        case 'Space':
        case 'Enter':
          this.onBasicUploaderClick();
          event.preventDefault();
          break;
      }
    }
    imageError(event) {
      this.onImageError.emit(event);
    }
    getBlockableElement() {
      return this.el.nativeElement.children[0];
    }
    get chooseButtonLabel() {
      return this.chooseLabel || this.config.getTranslation(TranslationKeys.CHOOSE);
    }
    get uploadButtonLabel() {
      return this.uploadLabel || this.config.getTranslation(TranslationKeys.UPLOAD);
    }
    get cancelButtonLabel() {
      return this.cancelLabel || this.config.getTranslation(TranslationKeys.CANCEL);
    }
    get browseFilesLabel() {
      return this.config.getTranslation(TranslationKeys.ARIA)[TranslationKeys.BROWSE_FILES];
    }
    ngOnDestroy() {
      if (this.content && this.content.nativeElement) {
        if (this.dragOverListener) {
          this.dragOverListener();
          this.dragOverListener = null;
        }
      }
      if (this.translationSubscription) {
        this.translationSubscription.unsubscribe();
      }
    }
    static ɵfac = function FileUpload_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FileUpload)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i2.HttpClient), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.PrimeNGConfig));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FileUpload,
      selectors: [["p-fileUpload"]],
      contentQueries: function FileUpload_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      viewQuery: function FileUpload_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 5);
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.advancedFileInput = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.basicFileInput = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
        }
      },
      hostAttrs: [1, "p-element"],
      inputs: {
        name: "name",
        url: "url",
        method: "method",
        multiple: [2, "multiple", "multiple", booleanAttribute],
        accept: "accept",
        disabled: [2, "disabled", "disabled", booleanAttribute],
        auto: [2, "auto", "auto", booleanAttribute],
        withCredentials: [2, "withCredentials", "withCredentials", booleanAttribute],
        maxFileSize: [2, "maxFileSize", "maxFileSize", numberAttribute],
        invalidFileSizeMessageSummary: "invalidFileSizeMessageSummary",
        invalidFileSizeMessageDetail: "invalidFileSizeMessageDetail",
        invalidFileTypeMessageSummary: "invalidFileTypeMessageSummary",
        invalidFileTypeMessageDetail: "invalidFileTypeMessageDetail",
        invalidFileLimitMessageDetail: "invalidFileLimitMessageDetail",
        invalidFileLimitMessageSummary: "invalidFileLimitMessageSummary",
        style: "style",
        styleClass: "styleClass",
        previewWidth: [2, "previewWidth", "previewWidth", numberAttribute],
        chooseLabel: "chooseLabel",
        uploadLabel: "uploadLabel",
        cancelLabel: "cancelLabel",
        chooseIcon: "chooseIcon",
        uploadIcon: "uploadIcon",
        cancelIcon: "cancelIcon",
        showUploadButton: [2, "showUploadButton", "showUploadButton", booleanAttribute],
        showCancelButton: [2, "showCancelButton", "showCancelButton", booleanAttribute],
        mode: "mode",
        headers: "headers",
        customUpload: [2, "customUpload", "customUpload", booleanAttribute],
        fileLimit: [2, "fileLimit", "fileLimit", value => numberAttribute(value, null)],
        uploadStyleClass: "uploadStyleClass",
        cancelStyleClass: "cancelStyleClass",
        removeStyleClass: "removeStyleClass",
        chooseStyleClass: "chooseStyleClass",
        files: "files"
      },
      outputs: {
        onBeforeUpload: "onBeforeUpload",
        onSend: "onSend",
        onUpload: "onUpload",
        onError: "onError",
        onClear: "onClear",
        onRemove: "onRemove",
        onSelect: "onSelect",
        onProgress: "onProgress",
        uploadHandler: "uploadHandler",
        onImageError: "onImageError",
        onRemoveUploadedFile: "onRemoveUploadedFile"
      },
      features: [i0.ɵɵInputTransformsFeature],
      decls: 2,
      vars: 2,
      consts: [["advancedfileinput", ""], ["content", ""], ["chooseSection", ""], ["basicfileinput", ""], [3, "ngClass", "ngStyle", "class", 4, "ngIf"], ["class", "p-fileupload p-fileupload-basic p-component", 4, "ngIf"], [3, "ngClass", "ngStyle"], ["type", "file", 3, "change", "multiple", "accept", "disabled"], [1, "p-fileupload-buttonbar"], [4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngTemplateOutlet"], [1, "p-fileupload-content", 3, "dragenter", "dragleave", "drop"], [3, "value", "showValue", 4, "ngIf"], [3, "value", "enableService"], ["class", "p-fileupload-files", 4, "ngIf"], ["class", "p-fileupload-empty", 4, "ngIf"], ["pRipple", "", "tabindex", "0", 1, "p-button", "p-component", "p-fileupload-choose", 3, "focus", "blur", "click", "keydown.enter", "ngClass"], [3, "ngClass", "class", 4, "ngIf"], [1, "p-button-label"], ["type", "button", 3, "label", "disabled", "styleClass", "onClick", 4, "ngIf"], [3, "ngClass"], [3, "styleClass", 4, "ngIf"], ["class", "p-button-icon p-button-icon-left", 4, "ngIf"], [3, "styleClass"], [1, "p-button-icon", "p-button-icon-left"], ["type", "button", 3, "onClick", "label", "disabled", "styleClass"], ["class", "p-button-icon p-button-icon-left", 3, "ngClass", 4, "ngIf"], [1, "p-button-icon", "p-button-icon-left", 3, "ngClass"], [3, "value", "showValue"], [1, "p-fileupload-files"], ["class", "p-fileupload-row", 4, "ngFor", "ngForOf"], [1, "p-fileupload-row"], [1, "p-fileupload-filename"], ["type", "button", "pButton", "", 1, "p-button-icon-only", 3, "click", "disabled"], [3, "error", "src", "width"], ["ngFor", "", 3, "ngForOf", "ngForTemplate"], [1, "p-fileupload-empty"], [1, "p-fileupload", "p-fileupload-basic", "p-component"], ["tabindex", "0", "pRipple", "", 3, "click", "keydown", "ngClass", "ngStyle"], [4, "ngIf", "ngIfElse"], ["class", "p-button-label", 4, "ngIf"], ["type", "file", 3, "accept", "multiple", "disabled", "change", "focus", "blur", 4, "ngIf"], ["class", "p-button-icon p-button-icon-left pi", 3, "ngClass", 4, "ngIf"], [1, "p-button-icon", "p-button-icon-left", "pi", 3, "ngClass"], ["class", "p-button-icon p-button-icon-left pi", 4, "ngIf"], [1, "p-button-icon", "p-button-icon-left", "pi"], ["type", "file", 3, "change", "focus", "blur", "accept", "multiple", "disabled"]],
      template: function FileUpload_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FileUpload_div_0_Template, 14, 42, "div", 4)(1, FileUpload_div_1_Template, 8, 17, "div", 5);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.mode === "advanced");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.mode === "basic");
        }
      },
      dependencies: () => [i4.NgClass, i4.NgForOf, i4.NgIf, i4.NgTemplateOutlet, i4.NgStyle, i5.ButtonDirective, i5.Button, i6.ProgressBar, i7.Messages, i8.Ripple, PlusIcon, UploadIcon, TimesIcon],
      styles: ["@layer primeng{.p-fileupload-content{position:relative}.p-fileupload-row{display:flex;align-items:center}.p-fileupload-row>div{flex:1 1 auto;width:25%}.p-fileupload-row>div:last-child{text-align:right}.p-fileupload-content .p-progressbar{width:100%;position:absolute;top:0;left:0}.p-button.p-fileupload-choose{position:relative;overflow:hidden}.p-button.p-fileupload-choose input[type=file],.p-fileupload-choose.p-fileupload-choose-selected input[type=file]{display:none}.p-fluid .p-fileupload .p-button{width:auto}.p-fileupload-filename{word-break:break-all}}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return FileUpload;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileUploadModule = /*#__PURE__*/(() => {
  class FileUploadModule {
    static ɵfac = function FileUploadModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FileUploadModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FileUploadModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule, ButtonModule, ProgressBarModule, MessagesModule, RippleModule, PlusIcon, UploadIcon, TimesIcon, SharedModule, ButtonModule, ProgressBarModule, MessagesModule]
    });
  }
  return FileUploadModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { FileUpload, FileUploadModule };
